import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { isMobile } from "react-device-detect";

import { LoadingComponent } from "../components/common";
import SidebarComponent from "../components/home/sidebarComponent";
import SubscriptionComponent from "../components/subscription/subscriptionComponent";
import { SessionUserStyles } from "./PagesStyle";

class SubscriptionPage extends Component {
	render() {
		const { classes, isLoading, mixpanel } = this.props;

		return (
			<div className={classes.root}>
				<CssBaseline />
				{!isMobile ? <SidebarComponent /> : null}
				<main className={classes.content}>
					<LoadingComponent isLoading={isLoading} />
					<div className={classes.appBarSpacer} />
					<SubscriptionComponent mixpanel={mixpanel} />
				</main>
			</div>
		);
	}
}

SubscriptionPage.propTypes = {
	classes: PropTypes.object.isRequired,
	isLoading: PropTypes.bool
};

const mapStateToProps = state => ({
	isLoading: state.subscription.isLoading
});

export default connect(
	mapStateToProps,
	null
)(withStyles(SessionUserStyles)(SubscriptionPage));
